import { FC } from 'react'

import { useParams } from '@tanstack/react-router'

import { Card, CardContent, Grid, Skeleton, Stack, Table } from '@forto-dev/phoenix-ui-core'

import { WidgetSkeleton } from '@/fragments/widgetSkeleton'
import { useLocalisation } from '@/utils/localisation'

import { BookingOverviewTabLayout } from '../BookingLayout'
import { BookingDetailsTitleSkeleton } from '../details/BookingDetailsSkeleton'

export const BookingContainersSkeleton: FC = () => {
  const { translate } = useLocalisation()
  const { id } = useParams({
    from: '/bookings/$id/containers',
  })
  return (
    <BookingOverviewTabLayout
      sidebar={<WidgetSkeleton count={2} />}
      title={<BookingDetailsTitleSkeleton />}
      main={
        <Stack gap={24}>
          <Card>
            <CardContent>
              <Stack gap={16}>
                <Grid col={4} gap={8}>
                  <Skeleton variant="badge" fullWidth />
                </Grid>
                <Grid col={6} gap={16}>
                  {Array.from({ length: 4 }).map((_, index) => (
                    <Skeleton key={index} variant="content" size={8} fullWidth />
                  ))}
                </Grid>
              </Stack>
            </CardContent>
          </Card>
          <Stack gap={12}>
            <Grid col={4} gap={8}>
              <Skeleton variant="badge" fullWidth />
            </Grid>
            <Table
              columns={[
                {
                  accessorKey: 'type',
                  header: translate('booking.containers.table.type'),
                  cell: () => <Skeleton variant="content" />,
                },
                {
                  accessorKey: 'quantity',
                  header: translate('booking.containers.table.quantity'),
                  cell: () => <Skeleton variant="content" />,
                },
              ]}
              data={[{}]}
              footless
            />
          </Stack>
          <Stack gap={12}>
            <Grid col={4} gap={8}>
              <Skeleton variant="badge" fullWidth />
            </Grid>
            <Table
              columns={[
                {
                  accessorKey: 'type',
                  header: translate('booking.packages.table.type'),
                  cell: () => <Skeleton variant="content" />,
                },
                {
                  accessorKey: 'quantity',
                  header: translate('booking.packages.table.quantity'),
                  cell: () => <Skeleton variant="content" />,
                },
              ]}
              data={[{}]}
              footless
            />
          </Stack>
        </Stack>
      }
      bookingId={id}
    />
  )
}
